module.exports = __webpack_public_path__ + "img/3.d7f093cd.png";